<template>
	<div class="class">
		<studentNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></studentNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white" v-if="JSON.stringify(data) != '{}'">
				<div class="class_title flex">
					<div class="my_position_l cl_gray">
						<img src="../../../static/icon_position.png" class="mar5" />
						<p>当前位置：学生端  >  <router-link to="/my_task" class="cl_gray">我的作业</router-link>  >  作业列表</p>
					</div>
					<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
				</div>
				<div class="my_task_title flex">
					<div class="my_task_title_l">
						<p class="f20px">{{data.homework_data.name}}</p>
						<p class="cl_gray mat15">布置人：{{data.homework_data.add_user_name}}</p>
						<p class="cl_gray mat5">{{data.homework_data.from_time}} ~ {{data.homework_data.to_time}}</p>
					</div>
					<div class="my_task_title_r">
						<div class="flex cl_dark">
							<p class="f18px">作业总进度：<span class="cl_gray">{{data.percentage*100}}%</span></p>
							<p class="f16px">已完成：<span class="cl_violet">{{data.done_num}}</span>/{{data.all_num}}</p>
						</div>
						<div class="mat15">
							<el-progress :percentage="data.percentage*100" :stroke-width="15" color="#FEB633" :show-text="false"></el-progress>
						</div>
						<p class="cl_red mat10">总进度在完成作业后1小时更新，请耐心等待！</p>
					</div>
				</div>
				<div class="my_task_cont mat10" v-if="data.data.length > 0">
					<div class="my_task_item radius8 bs cur flex mab30" v-for="(item,index) in data.data" :key="index"
					 @click="listCheck(item.id,item.item_type,item.is_done,item.pack_id)">
						<div class="flex">
							<img :src="item.pic" v-if="item.item_type == 'video'" class="my_task_item_img radius8" />
							<div class="f24px cl_white my_task_item_img_div" v-else>
								<img src="../../../static/icon_paper.png" class="my_task_item_img radius8 block" />
								<p v-if="item.item_type == 'test'">组卷</p>
								<p v-if="item.item_type == 'papers'">试卷</p>
								<p v-if="item.item_type == 'exam'">校本试卷</p>
							</div>
							<div class="my_task_item_test">
								<p class="f20px">{{item.name}}</p>
								<div class="cl_gray f16px mat30">
									<span v-if="item.item_type != 'video' && item.item_type != 'exam'">{{item.question_num}}题</span>
									<span v-if="item.item_type == 'exam'">（建议时长：{{item.period}}分钟）</span>
								</div>
							</div>
						</div>
						<img src="../../../static/icon_not.png" v-if="item.is_done == 0" />
						<img src="../../../static/icon_success.png" v-else />
					</div>
				</div>
				<div class="famous_page flex" v-if="data.data.length > 0">
					<div class="famous_page_l f16px cl_gray"> </div>
					<div class="famous_page_r cl_dark">
						<el-pagination background layout="prev, pager, next"
						@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import studentNav from '../../components/student_nav.vue'
	
	export default {
		name: 'my_task_list',
		components: {
			studentNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 1,
					listCur: 0,
					open: 0,
				},
				id: "",
				data: {},
				currentPage: 1, //当前页数
				pageSize: 10, //每页数量
				total: 0, //总页数
			}
		},
		created() {
			if (this.$route.query.id) {
				this.id = this.$route.query.id;
			}
		},
		mounted() {
			this.getList();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			getList () {
				this.$get("/api/student/get_my_homework_dtl_list",{
					token: localStorage.getItem("token"),
					id: this.id,
				})
				.then(res => {
					this.data = res.data;
					this.total = res.data.total;
				});
			},
			listCheck (id,type,done,pack_id) {
				if (type == 'video') {
					this.$router.push({path: '/video', query: {task_id: id, done: done, pack_id: pack_id}});
				}  else if (type == 'exam') {
					if (done == 0) {
						this.$router.push({path: '/task_school_paper', query: {id: id}});
					} else {
						this.$router.push({path: '/task_school_report', query: {id: id}});
					}
				} else {
					if (done == 0) {
						this.$router.push({path: '/practice_test', query: {task_id: id}});
					} else {
						this.$router.push({path: '/task_report', query: {id: id}});
					}
				}
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
			},
		},
	}
</script>

<style>
</style>
